"use strict";
/**
 * This is the main file of the package, it just re-exports all types.
 * Access all enums and errors as well as API schemas and types like this:
 * `* import { enums, errors, schemas, types } from '@truck-parking/tp-api'`
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = exports.schemas = exports.headers = exports.errors = exports.enums = exports.cookies = void 0;
exports.cookies = __importStar(require("./cookies"));
exports.enums = __importStar(require("./enums"));
exports.errors = __importStar(require("./errors"));
exports.headers = __importStar(require("./headers"));
exports.schemas = __importStar(require("./schemas"));
exports.types = __importStar(require("./types"));
//# sourceMappingURL=index.js.map